module.exports = __webpack_public_path__ + "static/junior-11-61acf8b99a98ff489f5c1709756bbb90.png";